import { Send } from "lucide-react";
import { CowMark } from "./CowMark";
import { XIcon } from "./OfficialLinks";
import { TELEGRAM_URL, X_URL } from "@/config";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  return (
  <footer
    data-testid="footer-section"
    className="border-t border-purple-500/20 bg-[#0E0E16]/60 px-5 pb-10 pt-16 sm:px-8"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center text-center">
      <div className="flex items-center gap-3">
        <CowMark size={44} />
        <span className="font-display text-3xl font-extrabold tracking-tight text-[#F5F3FF] sm:text-4xl">
          SOLMOO
        </span>
      </div>

      <p className="font-display text-flow mt-4 text-lg font-semibold sm:text-xl">
        {t("footer.slogan")}
      </p>
      <p className="font-display mt-3 text-sm font-bold uppercase tracking-[0.3em] text-gray-500 sm:text-base">
        {t("footer.mhm")}
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <a
          data-testid="footer-telegram-link"
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-purple-500/40 px-5 py-2.5 text-sm font-semibold text-purple-100 transition-colors hover:border-[#14F195]/60 hover:text-[#14F195]"
        >
          <Send size={15} />
          {t("footer.telegram")}
        </a>
        <a
          data-testid="footer-x-link"
          href={X_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-purple-500/40 px-5 py-2.5 text-sm font-semibold text-purple-100 transition-colors hover:border-[#14F195]/60 hover:text-[#14F195]"
        >
          <XIcon size={15} />
          {t("footer.x")}
        </a>
      </div>

      <p className="mt-10 max-w-2xl text-xs leading-relaxed text-gray-600">
        {t("footer.disclaimer")}
      </p>
      <p className="mt-3 font-jb text-xs text-gray-600">
        {t("footer.copyright")}
      </p>
    </div>
  </footer>
  );
};
